import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Bonjour!',
  ProductCode: 'faq42',
  Description:
    "Here's all the online content included with your <strong>French Exam Practice Workbook</strong>.",
  Credits:
    'With thanks to Marie-Laure Delvallée for the proofreading.\n' +
    '\n' +
    'Audio produced by Voice Talent Online.\n' +
    '\n' +
    'AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.\n' +
    '\n' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.',
};
